export default {
    language: "العربية",
    StripeSuccess: {
        loading: "جاري معالجة الدفع الخاص بك...",
        successMessage: "تم تفعيل اشتراكك بنجاح!",
        processingError: "فشل في معالجة الدفع، يرجى الاتصال بنا",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "البريد الإلكتروني",
            createdAt: "تاريخ الإنشاء",
            noRecord: "لا توجد سجلات",
            loginTime: "وقت تسجيل الدخول",
        },
        orders: {
            title: "سجل الطلبات",
            loading: "جاري التحميل...",
            refresh: "تحديث",
            orderAmount: "المبلغ",
            points: "النقاط",
            createdAt: "تاريخ الإنشاء",
            orderType: "النوع",
            status: "الحالة",
            noOrders: "لا توجد طلبات",
            goToSubscription: "شراء النقاط",
            freeCredit: "مجاني",
            paidCredit: "مدفوع",
            queryOrderFailed: "فشل في الاستعلام عن الطلب",
            statusPaid: "مدفوع",
            statusPending: "معلق",
            statusCancelled: "ملغى",
            statusDeactivated: "معطل",
            checkoutUrlNotAvailable: "فشل في الانتقال إلى الدفع",
            verifyingPayment: "جاري التحقق من الدفع...",
            paymentSuccess: "تم الدفع بنجاح",
            paymentPending: "الطلب في انتظار الدفع",
            paymentFailed: "فشل الدفع",
            paymentStatus: "حالة الدفع",
            paymentStatusDescription: "هل أكملت الدفع؟",
            cancelPayment: "إلغاء الدفع",
            completedPayment: "تم الدفع",
            warning: "تحذير",
            confirmCancelOrder: "هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.",
            cancel: "إلغاء",
            confirm: "تأكيد",
            cancellingOrder: "جاري إلغاء الطلب...",
            orderCancelledSuccess: "تم إلغاء الطلب",
            cancelOrderFailed: "فشل في إلغاء الطلب",
            checkOrderStatusFailed: "فشل في التحقق من حالة الطلب",
            promptClick: "انقر على حالة \"معلق\" لمتابعة الدفع",
        }
    },
    Order: {
        purchasePoints: "شراء النقاط",
        subtitle: "اختر باقة النقاط المناسبة للاستمتاع بخدمة إزالة العلامة المائية عالية الجودة",
        loginReminderDesc: "سجل الدخول لاختيار وشراء النقاط",
        freeTag: "مجاني",
        freePlan: "الخطة المجانية",
        autoActivated: "تفعيل تلقائي بعد تسجيل الدخول",
        points: "النقاط",
        autoIncluded: "هدية مجانية",
        discount: "خصم",
        purchase: "اشتر الآن",
        paymentStatusDescription: "هل أكملت الدفع؟",
        paymentNotCompleted: "الدفع غير مكتمل",
        queryOrderFailed: "فشل الاستعلام عن حالة الطلب",
        cancelPayment: "إلغاء الدفع",
        completedPayment: "اكتمل الدفع",
        warning: "تحذير",
        confirmCancelOrder: "هل أنت متأكد من رغبتك في إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.",
        cancel: "إلغاء",
        confirm: "تأكيد",
        selectProductFirst: "يرجى اختيار باقة أولاً",
        creatingOrder: "جاري إنشاء الطلب...",
        orderCreated: "تم إنشاء الطلب بنجاح",
        createOrderFailed: "فشل إنشاء الطلب",
        checkoutUrlNotAvailable: "فشل الحصول على رابط الدفع",
        cancellingOrder: "جاري إلغاء الطلب...",
        orderCancelledSuccess: "تم إلغاء الطلب",
        cancelOrderFailed: "فشل في إلغاء الطلب",
        verifyingPayment: "جاري التحقق من حالة الدفع...",
        paymentSuccess: "تم الدفع بنجاح",
        paymentPending: "الطلب في انتظار الدفع، يرجى إكمال الدفع",
        paymentFailed: "فشل الدفع أو تم إلغاؤه",
        checkOrderStatusFailed: "فشل في التحقق من حالة الطلب",
        quickStart: "البدء السريع",
        shortTerm: "استخدام قصير",
        recommended: "موصى به",
        bestValue: "أفضل قيمة",
    },
    Login: {
        title: "تسجيل الدخول",
        subtitle: "تسجيل الدخول السريع باستخدام حسابات التواصل الاجتماعي",
        memberTip: "سجل الدخول للوصول إلى المزيد من الميزات",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "تسجيل الدخول باستخدام حساب GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "تسجيل الدخول باستخدام حساب Google"
            }
        ],
        error: {
            serverError: "خطأ في الخادم، يرجى المحاولة لاحقًا",
            networkError: "خطأ في الشبكة، يرجى التحقق من اتصالك"
        }
    },
    OAuthCallback: {
        loading: "جاري معالجة طلب تسجيل الدخول",
        pleaseWait: "يرجى الانتظار، جاري التحقق من معلومات تسجيل الدخول...",
        error: "فشل تسجيل الدخول",
        backToHome: "العودة إلى الصفحة الرئيسية",
        success: "تم تسجيل الدخول بنجاح",
        redirecting: "جاري إعادة التوجيه إلى الصفحة الرئيسية..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "الأسعار",
            faq: "الأسئلة الشائعة",
        },
        login: "تسجيل الدخول",
        userMenu: {
            account: "الحساب",
            logout: "تسجيل الخروج",
            credit: "النقاط",
            freeCredit: "مجاني",
            paidCredit: "مشترى",
            nextUpdate: "التحديث التالي للنقاط",
            language: "اللغة",
            theme: "السمة",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "مميزات ClixMagicAI",
        advs: [
            {
                title: "محرك ذكاء اصطناعي للتعرف التلقائي: تحديد العناصر المتداخلة",
                desc: "باستخدام خوارزميات التعلم العميق، يتعرف تلقائياً على العلامات المائية والنصوص والوجوه والعناصر المعقدة في الصور/الفيديو، بدون الحاجة للتحديد اليدوي. يدعم منصات مثل انستغرام وتيك توك، مع حماية صارمة لخصوصية البيانات.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "إزالة العلامة المائية"
            },
            {
                title: "خبير تنقية الصور: إزالة الشعارات/الطوابع الزمنية بسرعة بدون فقدان الجودة",
                desc: "إزالة دقيقة للشعارات والتواريخ والملصقات. يقوم الذكاء الاصطناعي بإصلاح الخلفية تلقائياً، وتبدو الصور بعد المعالجة طبيعية كالأصل، مثالية لمنشورات وسائل التواصل الاجتماعي.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "إزالة العلامة المائية"
            },
            {
                title: "مزيل العلامات المائية المتحركة: إزالة النصوص المتحركة وشعارات المنصات",
                desc: "إزالة سهلة لعلامات يوتيوب وعلامات تيك توك المتحركة والنصوص المتدفقة. يتتبع الذكاء الاصطناعي ويعالج كل إطار، وينتج فيديو 4K سلس عالي الدقة، يدعم صيغ MP4/MOV وغيرها.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "إزالة العلامة المائية"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "أداة احترافية تعمل بالذكاء الاصطناعي لإزالة العلامات المائية بسرعة من الصور والفيديوهات وملفات PDF بعملية بسيطة ونتائج طبيعية.",
        fileTypes: {
            image: 'إزالة العلامات المائية من الصور',
            pdf: 'إزالة العلامات المائية من PDF',
            video: 'إزالة العلامات المائية من الفيديو'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "تجربة مجانية يومية", icon: "fa-gift" },
            { id: "imageTag", text: "إزالة العلامات المائية من الصور", icon: "fa-image" },
            { id: "videoTag", text: "إزالة العلامات المائية من الفيديو", icon: "fa-video" },
            { id: "aiPoweredTag", text: "مدعوم بالذكاء الاصطناعي", icon: "fa-robot" },
            { id: "noRegTag", text: "سجل واستخدم", icon: "fa-user-check" },
        ],
        videoPromt: "قريباً!",
        videoDesc: "نعمل على تطوير إزالة العلامات المائية من الفيديو لنقدم لك تجربة أقوى."
    },
    UserFeedback: {
        title: "آراء المستخدمين",
        feedback: "استمع إلى تقييمات حقيقية من المبدعين والمحترفين حول العالم لتقنية معالجة الصور بالذكاء الاصطناعي.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "السيد لين",
                profession: "محرر فيديو ومنشئ محتوى",
                rating: 5,
                comment: "رائع جدًا! ClixMagicAI سريع للغاية! قم بتحميل فيديو يحتوي على علامة مائية، وفي غضون دقائق يمكنك الحصول على نسخة بدون علامة مائية، دون أي فقدان في الجودة. إنها أداة أساسية لإزالة العلامات المائية!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "السيدة سو",
                profession: "خبيرة في وسائل التواصل الاجتماعي",
                rating: 5,
                comment: "لقد أنقذ ClixMagicAI مكتبة محتوى Instagram الخاصة بي! يمكنه التعرف على العلامات المائية المعقدة بدقة، ومعالجة الحواف أكثر نعومة من البرامج التي استخدمتها من قبل، مما يجعل التأثير البصري أكثر طبيعية."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "السيد تشن",
                profession: "منتج فيديو قصير",
                rating: 5,
                comment: "ClixMagicAI مريح جدًا لإزالة العلامات المائية. أقوم بمعالجة محتوى TikTok أثناء التنقل، وعند وصولي إلى المكتب أقوم بتنزيل النسخة عالية الدقة مباشرةً. تضاعفت الكفاءة! إنها نعمة لصانعي المحتوى."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "السيد هوانغ",
                profession: "مصمم جرافيك ومدير إبداعي",
                rating: 5,
                comment: "كمصمم، أنا راضٍ جدًا! عند معالجة الصور النموذجية التي تحتوي على شعار العميل، يتم إصلاح نسيج الخلفية بشكل طبيعي، دون أي آثار من فوتوشوب، مما يوفر الكثير من وقت المعالجة."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "السيدة إيميلي",
                profession: "منشئة محتوى رقمي مستقلة",
                rating: 5,
                comment: "اكتشفت كنزًا! سعر العضوية أرخص بكثير من منتجات إزالة العلامات المائية الأخرى في السوق، لكن نتائج إزالة العلامات المائية أفضل، خاصةً عند التعامل مع العلامات المائية الشفافة المتدرجة."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "السيد روبرتسون",
                profession: "منتج دورات تدريبية للشركات",
                rating: 5,
                comment: "ClixMagicAI مريح جدًا لأنه لا يتطلب تثبيتًا! قيود الأذونات على كمبيوتر الشركة تمنعني من تثبيت البرامج، والآن يمكنني معالجة مواد الدورة التدريبية باستخدام المتصفح، في أي وقت وأي مكان."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "السيدة تشو",
                profession: "ربة منزل ومحررة محتوى مجتمعي",
                rating: 5,
                comment: "واجهة التشغيل بسيطة لدرجة أن حتى جدتي يمكنها استخدامها! أولئك الذين ليس لديهم وقت لتعلم برامج متخصصة مثل فوتوشوب يجب أن يجربوا ClixMagicAI، فهو مناسب تمامًا للمستخدمين المبتدئين مثلي. هاها~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "السيد جونسون",
                profession: "مخطط بصري للتجارة الإلكترونية",
                rating: 5,
                comment: "ClixMagicAI قوي جدًا، يمكنه إزالة العلامات المائية من الصور والفيديو والأشياء الصغيرة والمارة والنصوص وغيرها، إنه شامل الوظائف، أوصي به للجميع~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "السيدة فانغ",
                profession: "هاوية تصوير ومشاركة محتوى على الإنترنت",
                rating: 5,
                comment: "واو~ أخيرًا وجدت أداة لإزالة العلامات المائية لا تضر بجودة الصورة! إنها سحرية! تحرير الصور لم يعد مشكلة! أوصي بها بشدة!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "السيد ويليامز",
                profession: "مدرس تعليم عبر الإنترنت",
                rating: 5,
                comment: "ميزة تذكر موقع العلامة المائية مفيدة للغاية! عند معالجة سلسلة من مقاطع فيديو الدورة التدريبية، لا أحتاج إلى اختيار المنطقة بشكل متكرر، مما يوفر على الأقل نصف ساعة من العمل، ويعزز كثيرًا من كفاءة تحضير التدريس."
            }
        ]
    },
    Footer: {
        social: {
            title: "اتصل بنا",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "الشروط القانونية",
        terms: [
            {
                id: 1,
                title: "سياسة الخصوصية",
                link: "/privacy"
            },
            {
                id: 2,
                title: "شروط الخدمة",
                link: "/terms"
            },
            {
                id: 3,
                title: "سياسة ملفات تعريف الارتباط",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI جميع الحقوق محفوظة."
    },
    Task: {
        image: {
            imageSupportText: 'يدعم تنسيقات jpg و jpeg و png و webp و heic و heif، بحد أقصى 10 ميجابايت للملف الواحد',
            imageFileTooLarge: 'حجم الملف يتجاوز الحد (10 ميجابايت كحد أقصى)',
            invalidImageType: 'تنسيق صورة غير مدعوم، يرجى تحميل JPG أو JPEG أو PNG أو WEBP أو HEIC أو HEIF',
            imageWillCost: 'ستكلف: 1 نقطة',
            hiecSupportText: 'سيتم تحويل تنسيقات HEIC/HEIF تلقائيًا إلى PNG عند التقديم',
            hiecSuccess: 'تم تحويل تنسيق HEIC/HEIF بنجاح',
            hiecFailed: 'فشل تحويل تنسيق HEIC/HEIF',
            processingImageTip: 'جاري معالجة صورتك، يرجى الانتظار...',
            guide: {
                title: 'دليل المستخدم',
                step1: 'تحميل الصورة',
                step2: 'رسم فوق منطقة العلامة المائية أو دع النموذج يكتشفها تلقائياً',
                step3: 'انقر على تقديم'
            }
        },
        common: {
            remaining: 'النقاط المتبقية',
            nextUpdate: 'التحديث التالي للنقاط',
            handleError: 'خطأ في معالجة الملف، يرجى تجربة ملف آخر',
            uploadFailed: 'فشل تحميل الملف',
            dragText: 'اسحب الملفات هنا أو',
            clickText: 'انقر للتحميل',
            loginRequired: 'يرجى تسجيل الدخول قبل تحميل الملفات',
            noRemainingTasks: 'لقد استخدمت جميع نقاطك',
            loginNow: 'تسجيل الدخول الآن',
            upgradeNow: 'شراء النقاط الآن',
            taskSubmitSuccess: 'تم تقديم المهمة بنجاح',
            taskSubmitError: 'فشل تقديم المهمة',
            taskRetrySuccess: 'تم إعادة تقديم المهمة بنجاح!',
            taskRetryError: 'فشل إعادة تقديم المهمة!',
            processing: 'جاري المعالجة',
            submit: 'تقديم',
            waiting: 'في الانتظار',
            completed: 'مكتمل',
            failed: 'فشل',
            cancelled: 'ملغى',
            url_not_found: 'فشل الحصول على الرابط',
            deleted: 'محذوف',
            refreshSuccess: 'تم تحديث قائمة المهام',
            refreshFailed: 'فشل تحديث قائمة المهام',
            deleteSuccess: 'تم حذف المهمة بنجاح',
            deleteFailed: 'فشل حذف المهمة',
            waitingForCompletion: 'يرجى الانتظار حتى اكتمال المهمة الحالية قبل إعادة المحاولة',
            loadOriginalImageFailed: 'فشل تحميل الصورة الأصلية، يرجى إعادة المحاولة',
            downloadFailed: 'فشل التنزيل',
            startingDownload: 'بدء التنزيل...',
            noTasks: 'لا توجد مهام',
            refresh: 'تحديث',
            sort: 'فرز',
            noFilterTasks: 'لا توجد مهام {filter}',
            compare: 'عرض المقارنة',
            originalImage: 'الأصلية',
            processedImage: 'المعالجة',
            dragToCompare: '👈 اسحب للمقارنة 👉',
            cancel: "إلغاء",
            delete: "حذف",
            retry: "إعادة المحاولة",
            download: "تنزيل",
            createAt: "تم الإنشاء في",
            expiredAt: "تنتهي في",
        },
        video: {
            videoSupportText: 'يدعم تنسيقات mp4 و mov و avi و mkv، بحد أقصى 100 ميجابايت للملف الواحد',
            videoFileTooLarge: 'حجم الملف يتجاوز الحد (100 ميجابايت كحد أقصى)',
            invalidVideoType: 'تنسيق فيديو غير مدعوم، يرجى تحميل MP4 أو MOV أو AVI أو MKV',
            videoWillCost: 'ستكلف: 3 نقاط',
            processingVideoTip: 'جاري معالجة الفيديو الخاص بك، يرجى الانتظار...',
            guide: {
                step1: 'تحميل الفيديو',
                step2: 'حدد نوع العلامة المائية وحدد منطقة العلامة المائية',
                step3: 'انقر على تقديم'
            },
            annotationTools: 'أدوات تعليم العلامة المائية',
            selectType: 'حدد نوع العلامة المائية',
            deleteAnnotation: 'حذف التعليم',
            clearAllAnnotations: 'مسح جميع التعليمات',
            annotationHelp: 'مساعدة التعليم',
            dragTip: 'اسحب لرسم منطقة العلامة المائية',
            resizeTip: 'غير الحجم ليتطابق مع العلامة المائية',
            moveTip: 'يمكن نقل التعليمات المنشأة',
            processing: 'جاري المعالجة',
            submit: 'تقديم',
            taskSubmitSuccess: 'تم تقديم المهمة بنجاح',
            taskSubmitError: 'فشل تقديم المهمة',
            retryTaskTip: 'نجحت إعادة المحاولة',
            retryFailed: 'فشلت إعادة المحاولة',
            uploadFailed: 'فشل التحميل',
            staticWatermarkDesc: 'للعلامات المائية الثابتة في مواقع ثابتة',
            normalWatermarkDesc: 'للعلامات المائية الثابتة العادية',
            dynamicWatermarkDesc: 'للعلامات المائية الديناميكية المتغيرة',
            moveWatermarkDesc: 'للعلامات المائية التي تحتاج إلى نقل'
        },
    },
    Router: {
        home: "الرئيسية",
        terms: "شروط الخدمة",
        privacy: "سياسة الخصوصية",
        cookie: "سياسة ملفات الارتباط",
        user: "مركز المستخدم",
    },
    Terms: {
        "tabs": {
            "terms": "شروط الخدمة",
            "privacy": "سياسة الخصوصية",
            "cookies": "سياسة ملفات تعريف الارتباط"
        },
        "lastUpdated": "آخر تحديث: 20 مايو 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. مقدمة",
                    "description": "مرحبًا بك في ClixMagicAI. استخدامك لخدماتنا يعني موافقتك على شروط الخدمة هذه. يرجى قراءتها بعناية."
                },
                {
                    "title": "2. وصف الخدمة",
                    "description": "تقدم ClixMagicAI أدوات مدعومة بالذكاء الاصطناعي لإزالة العلامات المائية من الصور والفيديوهات وملفات PDF. خدماتنا مخصصة للاستخدامات القانونية التالية:",
                    "items": [
                        "إزالة العلامات المائية من المحتوى الخاص بك",
                        "إزالة العلامات المائية من المحتوى الذي تملك حقوقًا مناسبة لتعديله",
                        "لأغراض تعليمية وبحثية"
                    ]
                },
                {
                    "title": "3. مسؤوليات المستخدم",
                    "description": "باستخدام ClixMagicAI، فإنك توافق على:",
                    "items": [
                        "تحميل المحتوى الذي تملكه أو لديك حقوق مناسبة لتعديله فقط",
                        "عدم استخدام خدماتنا لأي غرض غير قانوني أو ينتهك أي قانون",
                        "عدم محاولة التحايل على إجراءات الأمان لدينا أو قيود الاستخدام",
                        "عدم استخدام خدماتنا لانتهاك حقوق الملكية الفكرية للآخرين"
                    ]
                },
                {
                    "title": "4. شروط الحساب",
                    "description": "قد تحتاج إلى إنشاء حساب لاستخدام بعض ميزات خدماتنا. للتسجيل، يمكنك اختيار استخدام حساب Google أو GitHub. أنت مسؤول عن:",
                    "items": [
                        "الحفاظ على أمان حسابك",
                        "جميع الأنشطة التي تحدث تحت حسابك",
                        "تقديم معلومات دقيقة للحساب (بما في ذلك على سبيل المثال لا الحصر الصورة الرمزية والبريد الإلكتروني واسم المستخدم ومعرف المستخدم)"
                    ]
                },
                {
                    "title": "5. الخدمات المجانية والمدفوعة",
                    "description": "توفر ClixMagicAI حصة أساسية مجانية وخيارات شراء نقاط مرنة للوصول إلى ميزات إزالة العلامات المائية لدينا:",
                    "items": [
                        "الحصة الأساسية: سيحصل كل مستخدم تلقائيًا على 3 نقاط مجانية يوميًا، يمكن استخدامها لمعالجة المحتوى",
                        "قواعد استهلاك النقاط: تستهلك إزالة العلامات المائية من الصور نقطة واحدة لكل عملية، وتستهلك إزالة العلامات المائية من الفيديو 3 نقاط لكل عملية",
                        "شراء النقاط: يمكنك اختيار شراء حزم نقاط للحصول على مزيد من الاستخدام، جميع النقاط المشتراة صالحة بشكل دائم، بدون قيود انتهاء الصلاحية",
                        "سياسة الاسترداد: نظرًا للطبيعة الفورية والافتراضية للخدمات الرقمية، لا يمكن استرداد النقاط بمجرد شرائها بنجاح"
                    ]
                },
                {
                    "title": "6. حقوق الملكية الفكرية",
                    "description": "خدمة ClixMagicAI، بما في ذلك جميع البرامج والتصميمات والمحتوى الذي أنشأناه، هي ملكية فكرية لنا. لا يجوز لك نسخ أو تعديل أو إنشاء أعمال مشتقة بناءً على خدماتنا دون إذن."
                },
                {
                    "title": "7. حدود المسؤولية",
                    "description": "تقدم ClixMagicAI الخدمة \"كما هي\"، دون أي ضمانات من أي نوع. نحن لسنا مسؤولين عن أي أضرار ناتجة عن استخدامك لخدماتنا."
                },
                {
                    "title": "8. تغييرات الشروط",
                    "description": "يجوز لنا تعديل هذه الشروط في أي وقت. استمرار استخدام ClixMagicAI بعد تغيير الشروط يعني قبولك للشروط المعدلة."
                },
                {
                    "title": "9. الإنهاء",
                    "description": "نحتفظ بالحق في إنهاء أو تعليق وصولك إلى خدماتنا فورًا، دون إشعار مسبق، إذا اعتقدنا أن سلوكك ينتهك هذه الشروط أو يضر بالمستخدمين الآخرين أو بنا أو بأطراف ثالثة."
                },
                {
                    "title": "10. القانون المطبق",
                    "description": "تخضع هذه الشروط للقوانين السارية في مكان تسجيل شركتنا، بغض النظر عن تعارض الأحكام القانونية."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. مقدمة",
                    "description": "في ClixMagicAI، نقدر خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك عند استخدام موقعنا وخدماتنا. باستخدام موقعنا أو أي من خدماتنا، فإنك تقبل ممارسات معالجة البيانات الموضحة في هذه السياسة. نحن نلتزم بلوائح حماية البيانات المعمول بها."
                },
                {
                    "title": "2. المعلومات التي نجمعها",
                    "description": "قد نجمع الأنواع التالية من المعلومات:",
                    "items": [
                        { "bold": "معلومات الحساب", "text": "صورة المستخدم وعنوان البريد الإلكتروني واسم المستخدم ومعرف المستخدم المقدمة عند تسجيل الدخول عبر Google أو GitHub" },
                        { "bold": "بيانات الاستخدام", "text": "معلومات حول كيفية استخدامك لخدماتنا، بما في ذلك الميزات التي تم الوصول إليها ووقت الاستخدام" },
                        { "bold": "المحتوى المرفوع", "text": "الصور أو مقاطع الفيديو أو ملفات PDF التي تقوم بتحميلها للمعالجة" },
                        { "bold": "معلومات الدفع", "text": "معلومات الدفع عند شراء الاشتراك (تتم معالجتها بأمان من خلال بوابات دفع تابعة لجهات خارجية مثل Creem/Stripe/PayPal، نحتفظ فقط بسجلات حالة الدفع)" },
                        { "bold": "البيانات التقنية", "text": "عنوان IP، نوع المتصفح، معلومات الجهاز" }
                    ]
                },
                {
                    "title": "3. كيف نستخدم معلوماتك",
                    "description": "نستخدم معلوماتك لـ:",
                    "items": [
                        { "text": "تقديم وصيانة وتحسين خدماتنا" },
                        { "text": "معالجة وإكمال المعاملات" },
                        { "text": "إرسال إشعارات تقنية ورسائل دعم" },
                        { "text": "الرد على تعليقاتك وأسئلتك" },
                        { "text": "تحليل أنماط الاستخدام لتعزيز تجربة المستخدم، ومعالجة البيانات الشخصية فقط بالقدر اللازم لتحقيق أغراض الخدمة" },
                        { "text": "ضمان أن فترة تخزين البيانات الشخصية لا تتجاوز الوقت اللازم" },
                        { "text": "منع الاحتيال أو الأنشطة غير القانونية" }
                    ]
                },
                {
                    "title": "4. أمن البيانات",
                    "description": "نطبق تدابير أمنية تتوافق مع معايير الصناعة لحماية معلوماتك الشخصية:",
                    "items": [
                        { "text": "تشفير AES-256 للملفات أثناء النقل والتخزين" },
                        { "text": "معالجة البيانات الحساسة باستخدام هندسة عدم المعرفة" },
                        { "text": "تدقيق سجلات الأمان اليومية وفحص نقاط الضعف" },
                        { "text": "تتبع حقوق وصول الموظفين لمبدأ الحد الأدنى من الامتيازات" }
                    ]
                },
                {
                    "title": "5. مشاركة البيانات",
                    "description": "نحن لا نبيع معلوماتك الشخصية. قد نشارك المعلومات مع:",
                    "items": [
                        { "bold": "مزودي الخدمة", "text": "مقتصرة على معالجة البيانات اللازمة لتقديم خدمات محددة (مثل تخزين CloundFlare السحابي، وبوابات الدفع التابعة لجهات خارجية مثل Creem/Stripe/PayPal)، والتي تتطلب توقيع اتفاقيات معالجة البيانات" },
                        { "bold": "المتطلبات القانونية", "text": "عند استلام مذكرة استدعاء صالحة أو أمر محكمة أو إجراء قانوني آخر ينطبق علينا" }
                    ]
                },
                {
                    "title": "6. حقوقك",
                    "description": "وفقًا للقوانين السارية في منطقتك، قد تتمتع بالحقوق التالية:",
                    "items": [
                        { "text": "الوصول إلى نسخة من بياناتك الشخصية" },
                        { "text": "تصحيح المعلومات غير الدقيقة أو غير المكتملة" },
                        { "text": "حق حذف البيانات ('الحق في النسيان')، ما لم يكن لدينا سبب قانوني للاحتفاظ بها" },
                        { "text": "الاعتراض على أو تقييد أنواع معينة من معالجة البيانات" },
                        { "text": "حق نقل البيانات، يمكنك طلب نقل بياناتك" }
                    ]
                },
                {
                    "title": "7. خصوصية الأطفال",
                    "description": "خدماتنا غير موجهة للقاصرين دون سن 16 عامًا. وفقًا للمادة 8 من اللائحة العامة لحماية البيانات (GDPR)، يجب أن تقدم موافقة الطفل دون سن 16 عامًا من قبل الوالد أو الوصي. إذا علمت أن قاصرًا دون سن 16 عامًا قد قدم لنا معلومات شخصية، يرجى الاتصال بنا على الفور عبر support@clixmagic.com."
                },
                {
                    "title": "8. تغييرات هذه السياسة",
                    "description": "قد نقوم بتحديث سياسة الخصوصية هذه بشكل دوري. سنخطرك بأي تغييرات جوهرية من خلال نشر السياسة الجديدة على هذه الصفحة وتحديث تاريخ \"آخر تحديث\". بالنسبة للتغييرات الهامة، سنخطر المستخدمين عبر البريد الإلكتروني أو بطريقة بارزة أخرى."
                },
                {
                    "title": "9. اتصل بنا",
                    "description": "إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا عبر support@clixmagic.com. إذا كنت تعتقد أن بياناتك تمت معالجتها بشكل غير لائق أو لديك أي مخاوف، فلا تتردد في الاتصال بنا في أي وقت."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. ما هي ملفات تعريف الارتباط",
                    "description": "ملفات تعريف الارتباط هي ملفات نصية صغيرة توضع على جهاز الكمبيوتر أو الجهاز المحمول الخاص بك عند زيارة موقع ويب. تسمح لمواقع الويب بالتعرف على جهازك وتذكر ما إذا كنت قد زرت الموقع من قبل."
                },
                {
                    "title": "2. كيف نستخدم ملفات تعريف الارتباط",
                    "description": "تستخدم ClixMagicAI ملفات تعريف الارتباط لأغراض متعددة:",
                    "items": [
                        { "bold": "ملفات تعريف الارتباط الضرورية", "text": "مطلوبة للوظائف الأساسية لموقعنا (مثل إدارة الجلسات وميزات الأمان)" },
                        { "bold": "ملفات تعريف ارتباط التفضيلات", "text": "تتذكر إعداداتك وتفضيلاتك لتعزيز تجربتك، على سبيل المثال من خلال تذكر صورتك الرمزية واسم المستخدم وما إلى ذلك بعد تسجيل الدخول عبر Google أو GitHub" },
                        { "bold": "ملفات تعريف ارتباط التحليلات", "text": "تساعدنا على فهم كيفية تفاعل الزوار مع موقعنا من خلال جمع معلومات مجهولة" },
                        { "bold": "ملفات تعريف ارتباط التسويق", "text": "تتبع عادات التصفح لديك لتقديم إعلانات ذات صلة باهتماماتك" }
                    ]
                },
                {
                    "title": "3. أنواع ملفات تعريف الارتباط التي نستخدمها",
                    "subsection": [
                        {
                            "title": "3.1 ملفات تعريف الارتباط الضرورية",
                            "description": "هذه الملفات ضرورية للتشغيل السليم للموقع. تمكن الوظائف الأساسية مثل الأمان وإدارة الشبكة والوصول إلى الحساب (بما في ذلك تسجيل الدخول عبر Google وGitHub). يمكنك ضبط متصفحك لحظر هذه الملفات، ولكن قد لا تعمل بعض أجزاء الموقع بشكل صحيح."
                        },
                        {
                            "title": "3.2 ملفات تعريف ارتباط الأداء والتحليلات",
                            "description": "تساعدنا هذه الملفات على فهم كيفية تفاعل الزوار مع موقعنا من خلال جمع معلومات مجهولة. نستخدم هذه البيانات لتحسين موقعنا وخدماتنا. لا تجمع هذه الملفات معلومات يمكن أن تحدد هوية الزائر."
                        },
                        {
                            "title": "3.3 ملفات تعريف ارتباط الوظائف",
                            "description": "تسمح هذه الملفات لموقعنا بتذكر الاختيارات التي تقوم بها (مثل تفضيلات اللغة أو حالة تسجيل الدخول) لتوفير وظائف شخصية محسنة، مثل تذكر حالة تسجيل الدخول عبر Google أو GitHub."
                        },
                        {
                            "title": "3.4 ملفات تعريف ارتباط الاستهداف والإعلانات",
                            "description": "تُستخدم هذه الملفات لعرض إعلانات ذات صلة للزوار وتتبع فعالية حملاتنا الإعلانية. يرجى ملاحظة أنه نظرًا لاعتماد موقعنا بشكل أساسي على تسجيل الدخول من طرف ثالث (Google وGitHub)، تُستخدم هذه الملفات بشكل أساسي لتحسين تجربة المستخدم وليس للتسويق المباشر."
                        }
                    ]
                },
                {
                    "title": "4. إدارة ملفات تعريف الارتباط",
                    "description": "يمكنك التحكم في ملفات تعريف الارتباط وإدارتها بعدة طرق. تسمح معظم متصفحات الويب بإدارة تفضيلات ملفات تعريف الارتباط. يمكنك:",
                    "items": [
                        { "text": "حذف ملفات تعريف الارتباط من جهازك" },
                        { "text": "حظر ملفات تعريف الارتباط من خلال تنشيط إعدادات المتصفح التي تسمح لك برفض بعض أو كل ملفات تعريف الارتباط" },
                        { "text": "ضبط متصفحك ليخطرك عند استلام ملفات تعريف الارتباط" }
                    ]
                },
                {
                    "title": "5. ملفات تعريف الارتباط من جهات خارجية",
                    "description": "بعض ملفات تعريف الارتباط يتم وضعها من قبل جهات خارجية على موقعنا. قد تشمل هذه الجهات الخارجية خدمات التحليلات (مثل Google Analytics) وشبكات الإعلانات. نظرًا لطريقة عمل ملفات تعريف الارتباط (يمكن الوصول إلى ملفات تعريف الارتباط فقط من قبل الطرف الذي وضعها في الأصل)، لا نتحكم في استخدام ملفات تعريف الارتباط هذه من جهات خارجية ولا يمكننا الوصول إليها. بالنسبة للمستخدمين الذين يسجلون الدخول عبر Google وGitHub، سنضمن اتباع إرشادات الخصوصية لهذه المنصات عند التعامل مع المعلومات ذات الصلة."
                },
                {
                    "title": "6. تحديث سياسة ملفات تعريف الارتباط هذه",
                    "description": "قد نقوم بتحديث سياسة ملفات تعريف الارتباط هذه من وقت لآخر لتعكس التغييرات في التكنولوجيا أو اللوائح أو ممارسات أعمالنا. سيتم نشر أي تغييرات على هذه الصفحة وتحديث تاريخ المراجعة."
                },
                {
                    "title": "7. اتصل بنا",
                    "description": "إذا كانت لديك أي أسئلة حول استخدامنا لملفات تعريف الارتباط، يرجى الاتصال بنا عبر support@clixmagic.com."
                }
            ]
        }
    },
    FAQ: {
        title: "دليل استخدام ClixMagicAI والأسئلة الشائعة",
        prompt: "هل لديك أي مشاكل أو استفسارات؟ تواصل معنا في أي وقت: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "ما هو ClixMagicAI وكيف يعمل؟",
                answer: "ClixMagicAI هي أداة متقدمة لإزالة العلامات المائية مدعومة بالذكاء الاصطناعي. تدعم التعرف التلقائي على العلامات المائية في الصور والفيديوهات، وتوفر وظيفة التحديد اليدوي لمواقع العلامات المائية. للصور، تدعم تحويل العديد من التنسيقات وتضمن مخرجات عالية الجودة؛ وللفيديو، يمكنها معالجة العلامات المائية الثابتة والمتحركة وحتى المتغيرة الشكل."
            },
            {
                id : 2,
                question: "هل يوفر ClixMagicAI استخدامًا مجانيًا؟",
                answer: "نعم، نقدم خدمة مجانية أساسية بقيمة 3 نقاط يوميًا! يمكنك استخدامها لمعالجة الصور (استهلاك نقطة واحدة لكل مرة) أو الفيديو (استهلاك 3 نقاط لكل مرة). بالإضافة إلى ذلك، يمكنك شراء نقاط إضافية، والنقاط المشتراة صالحة للأبد."
            },
            {
                id : 3,
                question: "هل يمكنني شراء نقاط إضافية؟",
                answer: "بالتأكيد! بالإضافة إلى 3 نقاط مجانية يوميًا، يمكنك الحصول على نقاط إضافية من خلال خيارات الشراء لدينا. النقاط المشتراة ستكون صالحة بشكل دائم، بدون تاريخ انتهاء."
            },
            {
                id : 4,
                question: "ما هي تنسيقات الملفات المدعومة؟",
                answer: "بالنسبة للصور، ندعم تنسيقات PNG و JPEG و JPG و WEBP و HEIC و HEIF، حيث سيتم تحويل HEIC و HEIF تلقائيًا إلى PNG. أما بالنسبة للفيديو، فندعم العديد من التنسيقات بما في ذلك MP4 و MOV."
            },
            {
                id : 5,
                question: "كيف تحمون خصوصيتي؟",
                answer: "في ClixMagicAI، نولي أهمية كبيرة لخصوصية المستخدم. سيتم تشفير جميع الملفات المرفوعة، وحذفها تلقائيًا خلال 24 ساعة بعد اكتمال المعالجة. نحن لا نحتفظ بأي ملفات مستخدم أو معلومات ذات صلة."
            },
            {
                id : 6,
                question: "كيف يمكنني تسجيل الدخول إلى ClixMagicAI؟",
                answer: "ندعم تسجيل الدخول السريع عبر حسابات GitHub أو Google، مما يضمن أمان حسابك مع تبسيط عملية التسجيل."
            },
            {
                id : 7,
                question: "ما مدى سرعة المعالجة؟",
                answer: "بفضل خوادمنا عالية الأداء وخوارزميات الذكاء الاصطناعي المحسنة، يمكن إكمال معظم مهام إزالة العلامات المائية من الصور في غضون 10 ثوانٍ، بينما تستغرق إزالة العلامات المائية من الفيديو دقيقة واحدة فقط في أسرع حالاتها. قد يختلف الوقت الفعلي حسب حجم الملف وتعقيده."
            },
            {
                id : 8,
                question: "كيف ستكون النتيجة بعد المعالجة؟",
                answer: "تم تدريب نماذج الذكاء الاصطناعي لدينا بشكل مكثف، ويمكنها إزالة العلامات المائية من الصور والفيديوهات بذكاء، مع الحفاظ على جودة المحتوى الأصلي. سواء كانت العلامات المائية معترف بها تلقائيًا أو محددة يدويًا، يمكن إزالتها بشكل فعال، مما يضمن نتيجة نهائية طبيعية وبدون آثار."
            },
            {
                id : 9,
                question: "ما هي مدة صلاحية كل مهمة؟",
                answer: "بمجرد اكتمال المهمة، ستظل الملفات المعالجة متاحة على ClixMagicAI لمدة 24 ساعة للتنزيل. بعد انتهاء الصلاحية، سيتم حذف الملفات تلقائيًا من خوادمنا لحماية خصوصيتك."
            },
            {
                id : 10,
                question: "ما هو الحد الأقصى لحجم الملف؟",
                answer: "نقبل ملفات الصور بحجم أقصى 10 ميجابايت، وملفات الفيديو بحجم أقصى 100 ميجابايت. قد تحتاج الملفات التي تتجاوز هذه الحدود إلى ضغطها أو اقتصاصها قبل التحميل."
            }
        ]
    },
}